import { FLOWER_IDS, FLOWERS, type FlowerId } from './flowers';
import { levelFromXp } from './progression';
import type { GameState } from './state';

/**
 * Flowers the player can realistically grow right now: market seeds unlocked at
 * their level plus any hybrid they have bred (harvested or holding seeds for).
 */
export function obtainableFlowers(state: GameState): FlowerId[] {
  const level = levelFromXp(state.xp);
  return FLOWER_IDS.filter((id) => {
    const def = FLOWERS[id];
    if (def.seedCost !== null) return def.unlockLevel <= level;
    return (state.almanac[id]?.harvested ?? 0) > 0 || (state.seeds[id] ?? 0) > 0;
  });
}
